if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        // Lightbox images stay out of the initial page load, then load once the
        // page has finished loading so they're ready before anyone opens zoom.
        const warm = () =>
          'requestIdleCallback' in window
            ? requestIdleCallback(() => this.loadImages(), { timeout: 3000 })
            : setTimeout(() => this.loadImages(), 2000);
        if (document.readyState === 'complete') warm();
        else window.addEventListener('load', warm, { once: true });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        this.loadImages();
        super.show(opener);
        this.showActiveMedia();
      }

      // Lightbox images are rendered with data-src/data-srcset so they don't
      // download with the page; swap them in the first time the lightbox opens.
      loadImages() {
        this.querySelectorAll('img[data-src]').forEach((img) => {
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          img.src = img.dataset.src;
          img.removeAttribute('data-srcset');
          img.removeAttribute('data-src');
        });
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
